const API_BASE = import.meta.env.VITE_API_URL || '/api';

class ApiClient {
  constructor() { this.token = null; }
  setToken(t) { this.token = t; t ? localStorage.setItem('token', t) : localStorage.removeItem('token'); }
  getToken() { if (!this.token) this.token = localStorage.getItem('token'); return this.token; }

  async req(endpoint, opts = {}) {
    const headers = { 'Content-Type': 'application/json', ...opts.headers };
    const t = this.getToken();
    if (t) headers['Authorization'] = `Bearer ${t}`;
    const res = await fetch(`${API_BASE}${endpoint}`, { ...opts, headers });
    if (res.status === 401) { this.setToken(null); window.location.href = '/login'; throw new Error('Unauthorized'); }
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.error || 'Failed'); }
    return res.json();
  }

  async login(u, p) { const d = await this.req('/auth/login', { method: 'POST', body: JSON.stringify({ username: u, password: p }) }); this.setToken(d.token); return d; }
  async getMe() { return this.req('/auth/me'); }
  async register(u, p, d) { return this.req('/auth/register', { method: 'POST', body: JSON.stringify({ username: u, password: p, display_name: d }) }); }
  async listUsers() { return this.req('/auth/users'); }

  async listNotes(p) { const q = new URLSearchParams(p).toString(); return this.req(`/notes${q ? '?' + q : ''}`); }
  async getNote(id) { return this.req(`/notes/${id}`); }
  async createNote(d) { return this.req('/notes', { method: 'POST', body: JSON.stringify(d) }); }
  async updateNote(id, d) { return this.req(`/notes/${id}`, { method: 'PUT', body: JSON.stringify(d) }); }
  async deleteNote(id) { return this.req(`/notes/${id}`, { method: 'DELETE' }); }
  async toggleStar(id) { return this.req('/notes/star', { method: 'POST', body: JSON.stringify({ id }) }); }
  async shareNote(id) { return this.req('/notes/share', { method: 'POST', body: JSON.stringify({ id }) }); }
  async getRecent() { return this.req('/notes/recent'); }
  async getTags() { return this.req('/notes/meta/tags'); }
  async getFolders() { return this.req('/notes/meta/folders'); }
  async getGraph() { return this.req('/notes/meta/graph'); }

  async getTemplates() { return this.req('/templates'); }
  async createTemplate(d) { return this.req('/templates', { method: 'POST', body: JSON.stringify(d) }); }
  async deleteTemplate(id) { return this.req(`/templates/${id}`, { method: 'DELETE' }); }

  async getTrash() { return this.req('/trash'); }
  async restoreFromTrash(id) { return this.req('/trash/restore', { method: 'POST', body: JSON.stringify({ id }) }); }
  async permanentDelete(id) { return this.req('/trash/permanent', { method: 'DELETE', body: JSON.stringify({ id }) }); }
  async emptyTrash() { return this.req('/trash/empty', { method: 'DELETE' }); }

  async search(q, l = 20, o = 0) { return this.req(`/search?q=${encodeURIComponent(q)}&limit=${l}&offset=${o}`); }
  async searchSuggestions(q) { return this.req(`/search/suggest?q=${encodeURIComponent(q)}`); }

  async uploadFile(file, noteId) {
    const fd = new FormData(); fd.append('file', file); if (noteId) fd.append('noteId', noteId);
    const t = this.getToken();
    const res = await fetch(`${API_BASE}/upload`, { method: 'POST', headers: { Authorization: `Bearer ${t}` }, body: fd });
    if (!res.ok) throw new Error('Upload failed'); return res.json();
  }
  async listFiles(n) { return this.req(`/upload${n ? '?noteId=' + n : ''}`); }

  async aiChat(msg, nId) { return this.req('/ai/chat', { method: 'POST', body: JSON.stringify({ message: msg, noteId: nId }) }); }
  async aiResearch(topic) { return this.req('/ai/research', { method: 'POST', body: JSON.stringify({ topic }) }); }
  async aiResearchCreate(topic, folder, nId) { return this.req('/ai/research/create', { method: 'POST', body: JSON.stringify({ topic, folder, existingNoteId: nId }) }); }
  async aiSummarize(content) { return this.req('/ai/summarize', { method: 'POST', body: JSON.stringify({ content }) }); }
  async aiCommand(cmd, text) { return this.req('/ai/commands', { method: 'POST', body: JSON.stringify({ command: cmd, text }) }); }
  async aiAutocomplete(content, pos) { return this.req('/ai/autocomplete', { method: 'POST', body: JSON.stringify({ content, cursorPos: pos }) }); }
  async aiSmartTags(title, content) { return this.req('/ai/smart-tags', { method: 'POST', body: JSON.stringify({ title, content }) }); }
  async aiRelated(noteId) { return this.req(`/ai/related?noteId=${noteId}`); }

  async importNotes(notes, folder) { return this.req('/import', { method: 'POST', body: JSON.stringify({ notes, folder }) }); }
  async exportNotes() { const t = this.getToken(); const res = await fetch(`${API_BASE}/export`, { headers: { Authorization: `Bearer ${t}` } }); return res.json(); }
}

export const api = new ApiClient();
export default api;
